import { ref } from 'vue';
import { projectFirestore } from '../firebase/config';

const getItems = () => {
  const items = ref([]);
  const error = ref(null);

  const load = async () => {
    try {
      const res = await projectFirestore.collection('items').get();

      items.value = res.docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });
    } catch (err) {
      error.value = err.message;
      console.log(error.value);
    }
  };

  return { items, error, load };
};

export default getItems;
